import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

const Facebook: React.FC<SvgProps> = ({ color, ...props }) => (
  <Svg
    width="31"
    height="30"
    viewBox="0 0 31 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <Path
      d="M27.3672 0H3.63281C1.62968 0 0 1.57711 0 3.51563V26.4844C0 28.4229 1.62968 30 3.63281 30H27.3672C29.3703 30 31 28.4229 31 26.4844V3.51563C31 1.57711 29.3703 0 27.3672 0ZM28.5781 26.4844C28.5781 27.1305 28.0349 27.6563 27.3672 27.6563H20.4648V18.1055H24.206L24.8242 14.4727H20.4648V11.9531C20.4648 10.9585 21.2535 10.1953 22.2812 10.1953H24.7637V6.5625H22.2812C19.198 6.5625 16.7123 8.97949 16.7123 11.9633V14.4727H13.0781V18.1055H16.7123V27.6563H3.63281C2.9651 27.6563 2.42187 27.1305 2.42187 26.4844V3.51563C2.42187 2.86945 2.9651 2.34375 3.63281 2.34375H27.3672C28.0349 2.34375 28.5781 2.86945 28.5781 3.51563V26.4844Z"
      fill={color || '#000319'}
    />
  </Svg>
);

export default Facebook;
